import router from '@/core/router.js';
import request from '@/utilities/request';
import { SIGNINTYPE, countDown } from '@/utilities/index';
import { clearPollingSession } from '@/utilities/pollingSession';

export default {
  sendMFACode({ commit, state }, { method }) {
    commit('setIsCodeSentFail', false);
    window.clearInterval(state.counter);
    commit('setCounter', null);
    commit('setIsCountDowning', true);
    commit('setCoundownSec', 120);

    let counter;

    request
      .post('/signin/module.php/tmauth/mfasendcode', { send_otp_code: method })
      .then(() => {
        counter = countDown(
          120,
          (sec) => {
            commit('setCoundownSec', sec);
          },
          () => {
            commit('setIsCountDowning', false);
          },
        );

        commit('setCounter', counter);
      })
      .catch(() => {
        if (counter) {
          window.clearInterval(counter);
          commit('setCounter', null);
        }

        commit('setIsCountDowning', false);
        commit('setIsCodeSentFail', true);
      });
  },
  verifyMFACode({ commit, state, dispatch, getters }, verifyForm) {
    let postPath = '';
    let code = state.MFACode;

    commit('setIsVerifying', true);
    commit('setMFACodeErr', '');
    dispatch('triggerEvent', { eventName: `VerifyCode-${getters.currentMethod}` }, { root: true });

    if (getters.currentMethod === 'googleauth') postPath = '/signin/module.php/tmauth/mfaverifycodetotp';
    if (getters.currentMethod === 'sms') postPath = '/signin/module.php/tmauth/mfaverifycodesms';
    if (getters.currentMethod === 'email') postPath = '/signin/module.php/tmauth/mfaverifycodeemail';

    request
      .post(postPath, { code })
      .then(() => {
        window.clearInterval(state.counter);
        commit('setCounter', null);
        commit('setIsVerifying', false);
        dispatch(
          'triggerEvent',
          { eventName: `VerifyCodeSuccess-${getters.currentMethod}` },
          { root: true },
        );

        // 清理 reauth listener 和 polling session
        if (window.__reauthBeforeUnload) {
          window.removeEventListener('beforeunload', window.__reauthBeforeUnload);
          window.__reauthBeforeUnload = null;
        }
        clearPollingSession();

        // 檢查是否需要 email verification
        if (getters.needEmailVerification) {
          // redesign 模式：任何登入方式都需要驗證
          // 舊版模式：只有 email 登入需要驗證
          if (getters.isRedesign || state.signInType === SIGNINTYPE.email) {
            router.push({
              name: 'auth/signInVerifyEmail',
              query: getters.isRedesign ? { scenario: 'signin' } : {},
            });
            return;
          }
        }

        verifyForm.submit();
      })
      .catch(() => {
        commit('setIsVerifying', false);
        dispatch(
          'triggerEvent',
          { eventName: `VerifyCodeNG-${getters.currentMethod}` },
          { root: true },
        );
        commit('setMFACodeErr', state.lang.incorrectCode);
      });
  },
};
